import { frontendURL } from '../../../helper/URLHelper';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/sales'),
      name: 'sales_dashboard',
      component: () => import('./SalesPage.vue'),
      meta: { permissions: ['administrator', 'agent', 'custom_role'] },
    },
  ],
};
